import React from 'react';
import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';

export function DescriptionField() {
  const { t } = useTranslation('create-alarm-step');
  const form = Form.useFormInstance();

  return (
    <Form.Item
      name="nomeAlarme"
      label={t('create-alarm-step:stepTwo.createAlarmDescriptionField')}
      rules={[
        {
          required: true,
          message: t(
            'create-alarm-step:stepTwo.createAlarmDescriptionRequired',
          ),
        },
      ]}
    >
      <Input
        onChange={e => {
          const value = e.target.value.replace(/\s+/g, '_');
          form.setFieldValue('nomeAlarme', value);
          // Limpa os erros do campo quando o usuário começa a digitar
          form.setFields([
            {
              name: 'nomeAlarme',
              errors: [],
            },
          ]);
        }}
      />
    </Form.Item>
  );
}
